// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__36kxN","approved":"Status_approved__1U0pv","rejected":"Status_rejected__3SJ_C","expired":"Status_expired__3g1d7","label":"Status_label__1RsEW"};